var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('b-row', [_vm.$permissionAbility(_vm.TASK_DASHBOARD_TODAY_DEADLINE, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('TodayAssignedTable', {
    key: _vm.viewAs,
    attrs: {
      "is-subtask": _vm.showSubtasks,
      "viewAs": _vm.viewAs
    }
  })], 1) : _vm._e(), _vm.$permissionAbility(_vm.TASK_DASHBOARD_WEEK_DEADLINE, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('WeeklyDueTasks', {
    key: _vm.viewAs,
    attrs: {
      "is-subtask": _vm.showSubtasks,
      "viewAs": _vm.viewAs
    }
  })], 1) : _vm._e()], 1), _c('b-row', [_vm.$permissionAbility(_vm.TASK_DASHBOARD_BY_PHASE, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": _vm.viewAs !== 'employee' ? 6 : 12
    }
  }, [_c('TaskByPhaseChart', {
    key: _vm.viewAs,
    attrs: {
      "is-subtask": _vm.showSubtasks,
      "viewAs": _vm.viewAs
    }
  })], 1) : _vm._e(), _vm.$permissionAbility(_vm.TASK_DASHBOARD_BY_ASSIGNEE, _vm.permissions) && _vm.viewAs !== 'employee' ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": _vm.$permissionAbility(_vm.TASK_DASHBOARD_BY_PHASE, _vm.permissions) ? 6 : 12
    }
  }, [_c('TaskByAssigneeChart', {
    key: _vm.viewAs,
    attrs: {
      "is-subtask": _vm.showSubtasks,
      "viewAs": _vm.viewAs
    }
  })], 1) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-button-group', {
    staticClass: "w-100 d-flex justify-content-between mb-3"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.viewAs === 'employee' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.viewAs = 'employee';
      }
    }
  }, [_vm._v(" My Task ")]), _c('b-button', {
    attrs: {
      "variant": _vm.viewAs === 'supervisor' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.viewAs = 'supervisor';
      }
    }
  }, [_vm._v(" Supervisor ")]), _vm.$permissionAbility(_vm.TASK_DASHBOARD_VIEW_AS_ADMIN, _vm.permissions) ? _c('b-button', {
    attrs: {
      "variant": _vm.viewAs === 'admin' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.viewAs = 'admin';
      }
    }
  }, [_vm._v(" Admin ")]) : _vm._e()], 1), _c('b-button-group', {
    staticClass: "w-100 d-flex justify-content-between mb-3"
  }, [_c('b-button', {
    attrs: {
      "variant": !_vm.showSubtasks ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.showSubtasks = false;
      }
    }
  }, [_vm._v(" Tasks ")]), _c('b-button', {
    attrs: {
      "variant": _vm.showSubtasks ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.showSubtasks = true;
      }
    }
  }, [_vm._v(" Subtasks ")])], 1), _c('div', {
    staticClass: "mb-3"
  }, [_vm.$permissionAbility(_vm.TASK_DASHBOARD_STATISTICS, _vm.permissions) ? _c('DashboardStatisticsView', {
    key: _vm.viewAs,
    attrs: {
      "is-subtask": _vm.showSubtasks,
      "viewAs": _vm.viewAs
    }
  }) : _vm._e()], 1), _c('div', [_vm.$permissionAbility(_vm.TASK_DASHBOARD_ACTIVITY_LOG, _vm.permissions) ? _c('DashboardActivityLog', {
    key: _vm.viewAs,
    attrs: {
      "members": _vm.allMemberIdOptions,
      "is-subtask": _vm.showSubtasks,
      "viewAs": _vm.viewAs
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }